import React, { useState, useEffect, createRef } from "react";
import MonoBar from "./MonoBar";
import { updateRankElements } from "./../../../utils";
import StatsUtils from "../../../../../utils/stats";
import Spinner from "../../../components/Spinner";
import { getCurrentSummaryData, getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { connect } from "react-redux";
import { Dropdown, Menu, Icon } from "antd";
import "./MonoBarView.css";
import moment from "moment";
import { TYPE_SORT, SOURCE, SOURCES_LIST } from "./constants";
import FileSaver from "file-saver";
const TITLE_HEIGHT = 100;

const processData = (rawData, typeSort, kpi, source) => {
  const bySource = rawData[source] || {};

  const data = bySource.data || [];
  let topScores = { first: -Infinity, last: Infinity, second: -Infinity };
  const nbElements = data.length;
  const dicColors = {
    AUCHAN: "#983838",
    "AUCHAN SUPERMARCHE": "#F25353",
    CARREFOUR: "#3872C8",
    "CARREFOUR MARKET": "#6EB1FA",
    CORA: "#224392",
    "GEANT CASINO": "#92D54D",
    INTERMARCHE: "#000000",
    LECLERC: "#E7853A",
    U: "#52D2DA"
  };

  const sortedData = data.sort((a, b) => {
    if (typeSort === TYPE_SORT.ALPHABETICALLY) {
      if (a.dim_value > b.dim_value) return 1;
      else return -1;
    } else if (typeSort === TYPE_SORT.INCREASING) {
      if (a.value > b.value) return 1;
      else return -1;
    } else {
      if (a.value < b.value) return 1;
      else return -1;
    }
  });
  const values = sortedData.map(v => {
    const indicator = StatsUtils.roundKpiValue(kpi, v.value || 0);
    updateRankElements(indicator, topScores, nbElements);
    return indicator;
  });
  const labels = data.map(v => {
    const label = v.dim_value;
    const newestPercentage = StatsUtils.roundKpiValue(kpi, v.value || 0);

    return newestPercentage === topScores.first ||
      newestPercentage === topScores.second ||
      newestPercentage === topScores.third
      ? `★@${label}`
      : label;
  });
  const colors = data.map(v => dicColors[v.dim_value]);
  const datasets = [
    {
      data: values,
      backgroundColor: colors,
      borderColor: colors,
      borderWidth: 1
    }
  ];
  return { labels, datasets };
};
const MonoBarView = ({ kpi = {}, data = {}, loading, period }) => {
  const byRetailer = data.byRetailer || {};
  const monobarRef = createRef();
  const [source, setSource] = useState(SOURCE.RETAILER);
  const [typeSort, setTypeSort] = useState(TYPE_SORT.ALPHABETICALLY);
  const [sortedDataBar, setSortedDataBar] = useState(processData(data, typeSort, kpi, source));
  const globalData = { value: byRetailer.value, valueStr: byRetailer.valueStr, kpiLabel: kpi.long_label };
  useEffect(() => {
    setSortedDataBar(processData(data, typeSort, kpi, source));
  }, [data, typeSort, source]);

  const keysList = SOURCES_LIST.filter(item => Object.keys(data).findIndex(dataSource => dataSource === item.key) > -1);

  const selectedSource = keysList.find(item => item.key === source) || {};
  const title = selectedSource.title;
  return (
    <div style={{ height: "100%" }} id="monobar4">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ transform: `rotateZ(${-90}deg) translate(${-55}px, ${-30}px)` }} className="p-page-subtitle">
          {title}
        </h2>

        {!loading && (
          <div className="monobarview__dropdown" style={{ display: "flex" }}>
            <div
              onClick={() => {
                if (monobarRef.current && monobarRef.current.chartInstance && monobarRef.current.chartInstance.canvas) {
                  const canvasHistogramme = monobarRef.current.chartInstance.canvas;
                  const canvas = document.createElement("canvas");
                  const ctx = canvas.getContext("2d");
                  canvas.width = canvasHistogramme.width * 2;
                  canvas.height = canvasHistogramme.height * 2 + TITLE_HEIGHT;
                  ctx.fillStyle = "#FFFFFF";
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  ctx.fillStyle = "#000000";
                  ctx.font = "bold 26px Arial";
                  ctx.textAlign = "center";
                  ctx.fillText(
                    ` ${kpi.long_label} / ${title} du ${moment(period[0]).format("DD.MM.YYYY")} au ${moment(
                      period[1]
                    ).format("DD.MM.YYYY")}`,
                    canvas.width / 2,
                    TITLE_HEIGHT / 2
                  );
                  ctx.drawImage(
                    canvasHistogramme,
                    0,
                    TITLE_HEIGHT,
                    canvasHistogramme.width * 2,
                    canvasHistogramme.height * 2
                  );

                  FileSaver.saveAs(
                    canvas.toDataURL("image/png"),
                    `${kpi.long_label}_${title}_du_${moment(period[0]).format("DD-MM-YYYY")}_au_${moment(
                      period[1]
                    ).format("DD-MM-YYYY")}_histogramme.png`
                  );
                }
              }}
              style={{ marginRight: 10, cursor: "pointer" }}
            >
              <Icon type="camera"></Icon>
            </div>
            <Dropdown
              overlay={
                <Menu
                  style={{ width: 200 }}
                  onClick={({ key }) => {
                    setSource(key);
                  }}
                >
                  {keysList
                    .filter(item => item.key !== source)
                    .map(item => (
                      <Menu.Item key={item.key}>{item.title}</Menu.Item>
                    ))}
                </Menu>
              }
            >
              <div>
                <Icon type="database" />
              </div>
            </Dropdown>
            <Dropdown
              overlay={
                <Menu
                  style={{ width: 200 }}
                  onClick={({ key }) => {
                    setTypeSort(key);
                  }}
                >
                  {TYPE_SORT.INCREASING !== typeSort && (
                    <Menu.Item key={TYPE_SORT.INCREASING}>Trier par ordre croissant</Menu.Item>
                  )}
                  {TYPE_SORT.DECREASING !== typeSort && (
                    <Menu.Item key={TYPE_SORT.DECREASING}>Trier par ordre décroissant</Menu.Item>
                  )}
                  {TYPE_SORT.ALPHABETICALLY !== typeSort && (
                    <Menu.Item key={TYPE_SORT.ALPHABETICALLY}>Trier par ordre alphabétique</Menu.Item>
                  )}
                </Menu>
              }
            >
              <div>
                <Icon type="bar-chart" style={{ marginLeft: 10 }} />
              </div>
            </Dropdown>
          </div>
        )}
      </div>
      <div
        id="monobar3"
        style={{
          height: "95%",
          position: "relative"
        }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <MonoBar globalData={globalData} data={sortedDataBar} typeSort={typeSort} ref={monobarRef} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    period: state.stats.period,
    data: getCurrentSummaryData(state),
    loading: getTableLoading(state),
    kpi: getSummaryKpiSelected(state)
  };
};
export default connect(mapStateToProps, null)(MonoBarView);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/MonoBarView.js